module.exports = __webpack_public_path__ + "img/tooth-pic.31624c17.jpg";